import React from 'react';
import { Check } from 'lucide-react';
import './DashForm.css';

export default function DashFormStepper({ steps = [], current = 1, onSelect }) {
  return (
    <div className="dform-steps" role="tablist" aria-label="Progression du formulaire">
      {steps.map((label, idx) => {
        const n = idx + 1;
        const done = n < current;
        const active = n === current;

        return (
          <button
            key={label}
            type="button"
            className={`dform-step${active ? ' is-active' : ''}${done ? ' is-done' : ''}`}
            role="tab"
            aria-selected={active}
            onClick={() => onSelect?.(n)}
          >
            <span className="dform-step-dot">
              {done ? <Check size={16} strokeWidth={3} /> : n}
            </span>
            <span className="dform-step-label">{label}</span>
            {idx < steps.length - 1 && <span className="dform-step-line" aria-hidden="true" />}
          </button>
        );
      })}
    </div>
  );
}
